import React, { useEffect } from 'react'
import { map, pipe, prop, sum } from 'lodash/fp'
import { OctagonAlertIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useAnchorsAlertsQuery } from '@/entities/anchor'

import { Button } from '@/shared/components/ui/button'
import { Spinner } from '@/shared/components/ui/spinner'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { ampli } from '@/shared/lib/ampli'
import { useDrawer } from '@/shared/lib/drawer-manager'

const getTotalCount = pipe([map(prop('anchors')), sum])

export default function AnchorAssortmentTableAlertsButton() {
	const { t } = useTranslation()

	const alertsDrawer = useDrawer('ANCHOR_ASSORTMENT_ALERTS')
	const { data, isLoading } = useAnchorsAlertsQuery<number>(
		{},
		{
			select: getTotalCount,
		}
	)
	useEffect(() => () => alertsDrawer.close(), [])

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Button
					onClick={() => {
						ampli.alertsOpenClicked({
							alerts_of: 'anchoring',
						})
						alertsDrawer.open({
							drawerClassName: 'assortment-alerts-eastside',
						})
					}}
					className='relative'
					size='icon'
				>
					{isLoading ? <Spinner /> : <OctagonAlertIcon />}
					{!!data && (
						<span className='absolute -top-1 -right-1 flex size-3 ease-in-out'>
							<span className='absolute inline-flex size-full animate-ping rounded-full bg-destructive/50' />
							<span className='relative inline-flex size-3 rounded-full bg-destructive' />
						</span>
					)}
				</Button>
			</TooltipTrigger>
			<TooltipContent side='top' align='end'>
				{t('app.pricing_alerts')}
			</TooltipContent>
		</Tooltip>
	)
}
